import { StyleSheet, Font } from '@react-pdf/renderer';

const loadFonts = (pluginUrl) => {
   Font.register({
      family: 'Roboto',
      fonts: [
         {
            src: `${pluginUrl}/build/fonts/Roboto-Regular.ttf`,
            fontWeight: 'normal',
         },
         {
            src: `${pluginUrl}/build/fonts/Roboto-Bold.ttf`,
            fontWeight: 'bold',
         },
      ],
   });
};

const createStyles = (settings) => StyleSheet.create({
   body: {
      padding: 0,
      fontSize: 12,
      fontFamily: 'Roboto',
   },
   header: {
      fontSize: 12,
      marginBottom: 0,
      textAlign: 'center',
      paddingBottom: 10,
      backgroundColor: settings.setting?.gmpcp_hf_background_color || '#0084B4',
      color: settings.setting?.gmpcp_hf_text_color || '#f5f5f5',
      padding: 5,
   },
   galleryImagesContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 10,
      marginTop: 2,
      flexWrap: 'wrap',
      gap: 0,
   },
   galleryImage: {
      width: '33%',
   },
   footer: {
      
      textAlign: 'center',
      fontSize: 12,
      borderTop: '1px solid #ccc',
      padding: 5,
      backgroundColor: settings.setting?.gmpcp_hf_background_color || '#f5f5f5',
      color: settings.setting?.gmpcp_hf_text_color || '#f5f5f5',
   },
   contentSection: {
      padding: 10,
      gap: 10,
   },
   contentContainermaincolor:{
      backgroundColor: settings.setting?.gmpcp_background_color || '#f5f5f5',
      color: settings.setting?.gmpcp_text_color || '#f5f5f5',
   },
   contentContainermain:{
      
      fontSize:(settings.setting?.gmpcp_product_content_font_size || '10')
   },
   contentContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: 10,
      gap: 10,
   },
   leftContent: {
      width: (settings.setting?.gmpcp_image_width || '40')+'%',
   },
   rightContent: {
      width: (100-settings.setting?.gmpcp_image_width || '60')+'%',
   },
   productName: {
      fontSize: (settings.setting?.gmpcp_product_title_font_size || '16'),
      fontWeight: 'bold',
      marginBottom: 10,
   },
   productLink: {
      marginTop: 10,
      color: 'blue',
      textDecoration: 'underline',
   },
   boldLabel: {
      fontWeight: 'bold',
   },
   contentpart: {
      marginTop: 5,
   },
   categoryTitle:{
      fontSize: 20,
      fontWeight: 'bold',
      paddingTop: 5,
      paddingBottom: 5,
      textAlign:'center',
   },
   contentpartmain:{
     textAlign: settings.setting?.gmwcp_shop_text_align || 'left',
   }
});

export { createStyles, loadFonts };
